import { forwardRef, useEffect } from 'react';
import { type RectReadOnly } from 'react-use-measure';
import { cubicBezier, motion } from 'framer-motion';

import { MotionPicture } from '@/components/ui/Picture/Picture';

import { LightAnimation } from './LightAnimation';

import containerClosePng from '/img/modals/container-close.png';
import containerCloseWebp from '/img/modals/container-close.webp';
import containerOpenPng from '/img/modals/container-open.png';
import containerOpenWebp from '/img/modals/container-open.webp';

interface MotionContainerAnimationProps {
  rect: RectReadOnly;
}

const MotionContainerAnimation = forwardRef<
  HTMLDivElement,
  MotionContainerAnimationProps
>(({ rect }, ref) => {
  useEffect(() => {
    console.log(rect.bottom);
  }, [rect]);

  const containerImages = [
    {
      key: 'close-container',
      img: containerClosePng,
      webp: containerCloseWebp,
    },
    {
      key: 'open-container',
      img: containerOpenPng,
      webp: containerOpenWebp,
    },
  ];

  return (
    <div
      ref={ref}
      className="aspect-[260/164] w-[260px] mt-[4.625rem] mb-16 relative z-[3]"
    >
      <motion.div
        initial={{ y: '-100vh' }}
        animate={{ y: 0 }}
        transition={{
          delay: 0.3,
          duration: 0.5,
          ease: cubicBezier(0.68, -0.55, 0.27, 1.55),
        }}
        className="relative w-full h-full"
      >
        <LightAnimation />
        {containerImages.map(({ key, img, webp }) => (
          <MotionPicture
            initial={{
              opacity: key === 'close-container' ? 1 : 0,
              filter:
                'drop-shadow(0px 0px 0px rgba(0,0,0,0)) drop-shadow(0px 0px 0px rgba(255, 255, 255, 0))',
            }}
            animate={{
              opacity: key === 'close-container' ? 0 : 1,
              filter:
                'drop-shadow(0px 0px 16px #FFDF35) drop-shadow(0px 0px 2px rgba(255, 255, 255, 0.50))',
            }}
            transition={{
              delay: 0.6,
              duration: 0.3,
              ease: cubicBezier(0.68, -0.55, 0.27, 1.55),
            }}
            key={key}
            className="absolute top-0 left-0 w-full h-full block"
            img={img}
            webp={webp}
            alt={key}
          />
        ))}
      </motion.div>
    </div>
  );
});

export { MotionContainerAnimation };
